var map = {
	"./music-instructions.json": 4272,
	"./music-library-intro2024.json": 4273,
	"./music-library-launch2024.json": 4274,
	"./music-progression.json": 4275,
	"./startSourcesAdvanced.json": 4276,
	"./startSourcesSimple.json": 4277,
	"./startSourcesSimple2.json": 4278,
	"./startSourcesTracks.json": 4279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4024;